import { render, staticRenderFns } from "./CheckTouch.vue?vue&type=template&id=f7735610"
import script from "./CheckTouch.vue?vue&type=script&lang=js"
export * from "./CheckTouch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports